import React from "react";

interface TopRightCornerProps {
  className?: string;
}

const TopRightCorner: React.FC<TopRightCornerProps> = ({ className }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.5 8.5C9.5 8.76522 9.43754 9.06246 9.25 9.25C9.06246 9.43754 8.76522 9.5 8.5 9.5M1.5 9.5C1.23478 9.5 0.937536 9.43754 0.75 9.25C0.562464 9.06246 0.5 8.76522 0.5 8.5M0.5 1.5C0.5 1.23478 0.562464 0.937536 0.75 0.75C0.937536 0.562464 1.23478 0.5 1.5 0.5M9.5 4C9.5 4 9.5 3.94526 9.5 3.75C9.5 1.75 8 0.5 6 0.5M0.5 3.5V4M9.5 6V6.5M0.5 6V6.5M6.5 9.5H6M4 0.5H3.5M4 9.5H3.5"
        stroke="#64748B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TopRightCorner;
